import { track as trackNewRelic } from './newrelic';
import { track as trackDebug } from './debug';
import { track as trackActionTracker, trackSegment } from './action_tracker';
import { trackableParams } from './params';
import { getSegmentActionTrackerKey } from './credentials';

export function track(eventName, args) {
  let args_ = {
    ...args,
    ...trackableParams(),
  };
  trackNewRelic(eventName, args_);
  trackDebug(eventName, args_);
  trackSegment(eventName, args_, getSegmentActionTrackerKey());
  return trackActionTracker(eventName, args_);
}
